<template>
    <div class="pmtdiv">
        <smallbutton toplabel="Split Ticket" @click="start()" v-if="showButton" :buttonclass="buttonClass"/>
        <linkbutton toplabel="Split Ticket" @click="start()" v-if="!showButton"/>
        <!--  MODAL -->
          <actionmodalwide ref="mymodal"> 
            <template v-slot:body>
                <form  v-if="ticket!=null">
                    <label class="titlelabel">Split Ticket for Table {{ticket.TableNumber }}</label>
                    <div class="splitdiv">
                        <div>
                            
                            <div class="leftjustified margin10">
                                <label class="titlelabel">Line Items</label>
                            </div>
                            
                            <div :class="itemclass(li)"  v-for="li in ticket.lineItems" :key="li.id" :value="li.id"  @click="selectedItem=li">
                                <p class="leftjustified">{{ li.quantity }}</p>
                                <p class="leftjustified">{{ li.productName }}</p>
                                <p class="rightjustified">{{ li.amount | toCurrency }}</p>
                            </div>

                            <br>

                            
                            
                            <div class="vertFlex">
                                <label for class=" text-right totaltextdetail">Subtotal: {{ ticket.subTotal|toCurrency }}</label>
                                <label for class="text-right totaltextdetail discountcolor">Discount: {{ ticket.discountAmount|toCurrency }}</label>
                                <label for class="text-right totaltextdetail">Tax: {{ ticket.tax|toCurrency }}</label>
                                <label for class=" text-right totaltextdetail">Total: {{ ticket.total|toCurrency }}</label>
                            </div>
                        </div>
                        <div >
                            <div v-for="li in getGuestTotals" :key="li.name" :value="li.name" >
                                <div v-if="li.show">
                                    <div class="leftjustified margin10">
                                        <label class="titlelabel">{{ li.name }}</label>
                                    </div>

                                    <div class="panel-inner ticketlineitem"  v-for="li in filteredLineItems(li.name)" :key="li.id" :value="li.id" >
                                        <p class="leftjustified">{{ li.quantity }}</p>
                                        <p class="leftjustified">{{ li.productName }}</p>
                                        <p class="rightjustified">{{ li.amount | toCurrency }}</p>
                                        <linkbutton toplabel="Remove" @click="li.guestNumber=null"/>
                                    </div>
                                    <div class="panel-inner ticketlineitem" @click="selectedItem.guestNumber=li.name" >
                                        <p class="leftjustified" ></p>
                                    </div>
                                </div>
                                
                            </div>
                            


                           
                        </div>
                    </div>
                    
                    

                    
                    <smallbutton  @click="save" toplabel="Save"/>
                    <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel"/>
                    <div>
                        <label class="responsemessage">{{responseMessage}}</label>
                    </div>




                   



                </form>
                
                
            </template>
          </actionmodalwide>
        </div>
    </template>
    
    <script>
    import {mapFields} from 'vuex-map-fields'
    import format from '../../style/format.js'
    import smallbutton from '../controls/button.vue'
    import linkbutton from '../controls/linkbutton.vue'
    import actionmodalwide from '../controls/actionmodalwide.vue'
     import pos from '../../services/pos.js'
     import pos_culinary from '../../services/pos_culinary.js'
    export default {
        name:'splitticket',
        components:{
            smallbutton,
            linkbutton,
            actionmodalwide
        },
        props:{
           
            showButton:{
                type:Boolean,
                default:false
            },
            
            ticketId:{
                type:Number
            },
            buttonClass:{
                type:String,
                default:'button buttonprimary bottom10'
            }
            
        },
        mixins:[format, pos,pos_culinary],
        data(){
            return{
                name:'Detail',
                trueParam:true, 
                selectedItem:{id:0}
                
            }
        },
        computed:{
            ...mapFields([
                'responseMessage',
                'pleaseWait',
                'location',
                'terminalId'
     
            ]),
            
        },
        methods:{
            itemclass(li){
                var cls="  ticketlineitem"
                if(li.guestNumber!=null){
                    cls = cls + " panel-inner-split-used"
                }else if(li.id==this.selectedItem.id){
                    cls=cls + " panel-inner-split-selected"
                }else{
                    cls=cls + " panel-inner-split"
                }
                return cls
            },
            filteredLineItems(guestnumber){
                var items = this.ticket.lineItems
                
                if(items!=undefined){
                    items = items.filter((item)=>{
                        return (item.guestNumber==guestnumber)
                    })
                }
                return items
            },
            amount(pi){
                var amt = pi.amount
                if(pi.changeGiven>0){
                     amt = pi.amount - pi.changeGiven
                }
                return this.$options.filters.toCurrency(amt)
            },
            toDate(dt){
                return this.$options.filters.formatTime(dt);
            },
           
            
            ticketclass(g){
                let c = "guestdetails panel-inner"
                if(g.id==this.ticketId){
                    c=c+" color-highlight"
                }else{c=c+" color-inner"}
                return c
            },
            selectTicket(id){
                console.log('sel ' + id)
                this.ticketId=id
            },
            start(){
  
                this.$refs.mymodal.openModal()
            },
            save(){
                this.UpdateLineItemGuestNumbers()
                this.$refs.mymodal.closeModal()
            }
                
        }
    }
    
    </script>
    
    <style>
    .panel-inner-split {
        padding: var(--padding-default);
        margin: var(--margin-default);
        border: var(--border-default);
        border-radius: var(--border-radius-default);
    }
    .panel-inner-split-selected{

        padding: var(--padding-default);
        margin: var(--margin-default);
        border:1px yellow solid;
        border-radius: var(--border-radius-default);
    }
    .panel-inner-split-used {
        padding: var(--padding-default);
        margin: var(--margin-default);
        border: var(--border-default);
        border-radius: var(--border-radius-default);
        background-color: lightgray;
    }
    .splitdiv{
        display:grid;
        grid-template-columns: 1fr 1fr;
    }
    .ticketlineitem{
        display:grid;
        grid-template-columns: 1fr 3fr 1fr auto;
    }
    .paymentitem{
        display:grid;
        grid-template-columns: 1fr 3fr 1fr;
    }
    .ticketfield{
        min-width:100px;
    }
    .ticketrecord{
        display:grid;
        grid-template-columns: 1fr 1fr 4fr 1fr 1fr 2fr 2fr;
    }
    .leftjustify{
        text-align: left;
    }
    .rightjustify{
        text-align: right;
    }
    .totaltextdetail{
        font-size:inherit;
        margin:5px 20px 5px 5px;
    }


/* for my test */
    .grid-container {
      display: grid;
      grid-template-columns: 100px repeat(5, 150px); /* 1 fixed + 5 content columns */
      grid-auto-rows: 50px;
      width: 600px;
      height: 250px;
      overflow: auto;
      border: 1px solid #ccc;
      position: relative;
    }

    .cell {
      border: 1px solid #ccc;
      padding: 10px;
      background: white;
    }

    .header2 {
      position: sticky;
      top: 0;
      background: #f8f8f8;
      z-index: 2;
    }

    .side-header {
      position: sticky;
      left: 0;
      background: #f0f0f0;
      z-index: 1;
    }

    .corner-header {
      z-index: 3;
    }
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    